/**
 * Header'daki SinyalX logosu.
 *
 * Saf gorsel katman: `pointer-events: none`, sadece susleme (bkz. theme.css
 * .brand-watermark) - tiklama/etkilesim ALMAZ, sinyal hesaplama/API/backend
 * mantigina dokunmaz.
 *
 * Iki ayri PNG kullanilir (kirmizi/yesil mum ikonu HARIC, logonun
 * beyaz/siyah kisimlari): kaynak goruntude "beyaz" pikseller aslinda
 * degisken gri tonlardi (anti-aliasing), koyu zeminde soluk/farkli
 * gorunuyordu ve acik temada hic kontrasti yoktu. Kirmizi/yesil olmayan
 * (dogrusal olmayan) pikseller tek renge sabitlenerek iki temiz varyant
 * uretildi - koyu tema icin duz beyaz, acik tema icin duz siyah.
 */

const LOGO_DARK_URL = "/branding/sinyalx-logo-dark.png";
const LOGO_LIGHT_URL = "/branding/sinyalx-logo-light.png";

export function BrandWatermark({ theme }: { theme: "light" | "dark" }) {
  return (
    <img
      className="brand-watermark"
      src={theme === "light" ? LOGO_LIGHT_URL : LOGO_DARK_URL}
      alt=""
      aria-hidden="true"
    />
  );
}
